import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Coaching requests use host-rooted /coaching/schedule-loan and /coaching/schedule-tas paths. The
 * request manager supplies auth and rejects non-2xx responses; callers own boolean success/error
 * adaptation.
 */

const coachingUrl = (path: string): string => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'coaching' },
    op: 'query',
    resourcePath: 'coaching',
  };
  return `${buildBaseURL(opts)}/${path.replace(/^\/+/, '')}`;
};

/**
 * POST /coaching/schedule-loan
 * body `{ scheduleRequestContent }`
 *
 * Mirrors `ApplicationAdapter#submitNonTaRequest`, which sent
 * `fetch(`${this.host}/coaching/schedule-loan`, { method: 'POST', body:
 * JSON.stringify({ scheduleRequestContent }) })`.
 */
export function submitNonTaCoachingRequest(scheduleRequestContent: string): RequestInfo {
  return {
    url: coachingUrl('schedule-loan'),
    method: 'POST',
    body: JSON.stringify({ scheduleRequestContent }),
    cacheOptions: { [SkipCache]: true },
  };
}

/**
 * POST /coaching/schedule-tas
 * body `{ mentorRequestContent }`
 *
 * Mirrors `ApplicationAdapter#submitTasRequest`, which sent
 * `fetch(`${this.host}/coaching/schedule-tas`, { method: 'POST', body:
 * JSON.stringify({ mentorRequestContent }) })`.
 */
export function submitTasCoachingRequest(mentorRequestContent: string): RequestInfo {
  return {
    url: coachingUrl('schedule-tas'),
    method: 'POST',
    body: JSON.stringify({ mentorRequestContent }),
    cacheOptions: { [SkipCache]: true },
  };
}
